/* Buttons: one shape, four tones (prototype .btn). */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: var(--primary);
  color: var(--on-primary);
  font-weight: 500;
  font-size: 15px;
  white-space: nowrap;
  text-decoration: none;
  transition:
    background-color 0.18s var(--ease),
    border-color 0.18s var(--ease),
    color 0.18s var(--ease);
}
.btn:hover {
  background: var(--primary-h);
}
.btn:disabled,
.btn[aria-disabled='true'] {
  opacity: 0.38;
  cursor: not-allowed;
}
.ghost {
  background: transparent;
  color: var(--ink);
  border-color: var(--line-2);
}
.ghost:hover {
  border-color: var(--ink);
  background: transparent;
}
.gold {
  background: var(--sand);
  color: #14201d;
}
.gold:hover {
  background: #d6ca96;
}
.light {
  background: #fff;
  color: #0e1a17;
}
.light:hover {
  background: #ece9df;
}
.danger {
  background: var(--crit);
  color: #fff;
}
.danger:hover {
  background: var(--crit);
  filter: brightness(0.94);
}
.sm {
  height: 36px;
  padding: 0 14px;
  font-size: 14px;
  border-radius: 8px;
}
.lg {
  height: 54px;
  padding: 0 30px;
  font-size: 16px;
  border-radius: 12px;
}
.block {
  width: 100%;
}
.busy {
  position: relative;
  color: transparent !important;
}
.busy::after {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-color: var(--on-primary) transparent var(--on-primary) transparent;
  animation: spin 0.8s linear infinite;
}
.ghost.busy::after {
  border-color: var(--ink) transparent var(--ink) transparent;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Round icon button (prototype .xbtn). */
.xbtn {
  border: 1px solid var(--line);
  background: var(--surface);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: var(--ink);
  flex: none;
}
.xbtn:hover {
  border-color: var(--ink);
}
